import { useEffect } from 'react';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { LoggingUserTypeEnum } from './LogType';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';

const useGa4 = () => {
  const { data: userInfo } = useUserInfo();
  const { isMatchingUser, isAuthorityUser, isReceivingMatchingUser } = useCheckAuthority(userInfo);

  const getUserType = () => {
    if (isMatchingUser) {
      return LoggingUserTypeEnum.MATCHING_ON;
    }
    if (userInfo?.id) return LoggingUserTypeEnum.USER;
    return LoggingUserTypeEnum.NOT_USER;
  };

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag('set', 'user_properties', {
      userType: getUserType(),
      cc: isAuthorityUser,
      receivedMatch: isReceivingMatchingUser,
    });
  }, [userInfo]);
};

export default useGa4;
